import {btn, Button, hr, menu, t} from "@intermesh/goui";
import {entities, modules} from "@intermesh/groupoffice-core";
import {cardDS} from "./Index.js";
import {ColumnGrid} from "./ColumnGrid.js";
import {SearchWindow} from "./SearchWindow.js";
import {ProjectWindow} from "@intermesh/business-projects3";

export class ColumnAddButton extends Button {
	private readonly boardId: string;
	private readonly columnId: string;
	private columnGrid: ColumnGrid;

	constructor(boardId: string, columnId: string, columnGrid: ColumnGrid) {
		super();

		this.boardId = boardId;
		this.columnId = columnId;
		this.columnGrid = columnGrid;

		this.icon = "add";

		this.menu = menu();

		this.menu.items.add(
			btn({
				text: t("Existing item"),
				icon: "search",
				handler: () => {
					const win = new SearchWindow(boardId, columnId);

					win.on("close", () => {
						this.columnGrid.load(this.boardId);
					});

					win.show();
				}
			}),
			hr(),
		)

		if (modules.isAvailable("community", "tasks")) {
			const taskConfig = entities.getLinkConfig("Task")!;

			this.menu.items.add(
				btn({
					iconCls: taskConfig.iconCls,
					text: taskConfig.title,
					handler: () => {
						const win = new go.modules.community.tasks.TaskDialog();

						win.redirectOnSave = false;

						win.on('save', (dlg: any, data: any) => {
							cardDS.create({
								boardId: this.boardId,
								columnId: this.columnId,
								entityId: data.id,
								entity: "Task"
							});

							this.columnGrid.load(this.boardId);
						});

						win.show();
					}
				})
			)
		}

		if (modules.isAvailable("business", "support")) {
			const supportConfig = entities.getLinkConfig("SupportTicket")!;

			this.menu.items.add(
				btn({
					iconCls: supportConfig.iconCls,
					text: supportConfig.title,
					handler: () => {
						const win = new go.modules.community.tasks.TaskDialog({
							role: "support",
							entityStore: "SupportTicket"
						});

						win.redirectOnSave = false;

						win.on('save', (dlg: any, data: any) => {
							cardDS.create({
								boardId: this.boardId,
								columnId: this.columnId,
								entityId: data.id,
								entity: "SupportTicket"
							});

							this.columnGrid.load(this.boardId);
						});

						win.show();
					}
				})
			)
		}

		if (modules.isAvailable("business", "projects3")) {
			const projectConfig = entities.getLinkConfig("Project3")!;

			this.menu.items.add(
				btn({
					iconCls: projectConfig.iconCls,
					text: projectConfig.title,
					handler: () => {
						const dlg = new ProjectWindow();

						dlg.form.on("save", ({data}) => {
							cardDS.create({
								boardId: this.boardId,
								columnId: this.columnId,
								entityId: data.id,
								entity: "Project3"
							});

							this.columnGrid.load(this.boardId);
						});

						dlg.show();
					}
				})
			)
		}
	}

}
